import type { ReactNode } from 'react'

export interface SegmentItem<K extends string> {
  key: K
  label: string
  icon?: ReactNode
  disabled?: boolean
  /** Метка «скоро» (для ещё не реализованных разделов, напр. Авто-бот = этап 17). */
  soon?: boolean
  /** §7: индикатор слева от пункта — горит, когда бот включён. ``undefined`` = нет индикатора. */
  dot?: boolean
}

interface SegmentControlProps<K extends string> {
  items: SegmentItem<K>[]
  value: K
  onChange: (key: K) => void
  ariaLabel?: string
}

export function SegmentControl<K extends string>({
  items,
  value,
  onChange,
  ariaLabel = 'Разделы',
}: SegmentControlProps<K>) {
  // Это переключение разделов SPA (маршрутизация), а не вкладки с панелями, поэтому
  // используем nav + aria-current, а не неполную семантику tablist/tab (которой нужны
  // tabpanel/aria-controls и стрелочная навигация).
  return (
    <nav className="segment" aria-label={ariaLabel}>
      {items.map((item) => {
        const active = item.key === value
        return (
          <button
            key={item.key}
            type="button"
            aria-current={active ? 'page' : undefined}
            disabled={item.disabled}
            className={`segment__btn${active ? ' is-active' : ''}`}
            onClick={() => !item.disabled && onChange(item.key)}
            title={item.soon ? 'Скоро (этап 17)' : undefined}
          >
            {item.dot !== undefined ? (
              <span
                className={`segment__dot${item.dot ? ' is-on' : ''}`}
                aria-hidden="true"
                title={item.dot ? 'Бот работает' : 'Бот выключен'}
              />
            ) : null}
            {item.icon}
            <span>{item.label}</span>
            {item.soon ? <span className="segment__soon">скоро</span> : null}
          </button>
        )
      })}
    </nav>
  )
}
